import TabPanel, {TabTextContent} from '../../components/TabPanel'
import SetupIAMPolicyCLI from './_03_setup_iam_policy_cli.mdx'
import SetupIAMPolicyConsole from './_03_setup_iam_policy_console.mdx'

export const IAMPolicyCreation = () => {
  const tabs = [
    [ 'cli', 'CLI' ],
    [ 'console', 'console'],
  ];
  return (
    <TabPanel items={tabs}>
      {(idx) => {
        const tab = tabs[idx][0];
        switch (tab) {
          case 'cli':
            return <TabTextContent><SetupIAMPolicyCLI /></TabTextContent>;
          case 'console':
            return <TabTextContent><SetupIAMPolicyConsole /></TabTextContent>;
          default:
            return null;
        }
      }}
    </TabPanel>
  )
}

### Set up IAM policy

You need to set up an IAM policy for the instance where the collector will run,
so that the collector can access RDS information.

<IAMPolicyCreation />

This policy grants the following access:

- RDS metadata used to discover general instance information
- Cloudwatch metrics to show CPU utilization and other system metrics in pganalyze
- RDS log file download (for [pganalyze Log Insights](https://pganalyze.com/log-insights))

To learn more about each access, see [Amazon RDS and Aurora: IAM Policy](https://pganalyze.com/docs/install/amazon_rds/iam_policy).
